function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForwardClone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    id: "screenshot-50002c00-9627-80a8-8005-e4f18e01d918",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-50002c00-9627-80a8-8005-e4f18e01d918",
    width: 800,
    height: 800,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-50002c00-9627-80a8-8005-e4f18e0249eb",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-50002c00-9627-80a8-8005-e4f18e0249eb"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-50002c00-9627-80a8-8005-e4f18e0249ec"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-50002c00-9627-80a8-8005-e4f18e0249ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.000,6.667L16.000,4.000C16.000,3.264,15.403,2.667,14.667,2.667L4.000,2.667C3.264,2.667,2.667,3.264,2.667,4.000L2.667,14.667C2.667,15.403,3.264,16.000,4.000,16.000L6.667,16.000L6.667,8.000C6.667,7.264,7.264,6.667,8.000,6.667Z",
    className: "clr-i-solid clr-i-solid-path-1",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-50002c00-9627-80a8-8005-e4f18e0249ed"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-50002c00-9627-80a8-8005-e4f18e0249ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.000,8.000L9.333,8.000C8.597,8.000,8.000,8.597,8.000,9.333L8.000,20.000C8.000,20.736,8.597,21.333,9.333,21.333L20.000,21.333C20.736,21.333,21.333,20.736,21.333,20.000L21.333,9.333C21.333,8.597,20.736,8.000,20.000,8.000ZZM18.667,15.333L15.333,15.333L15.333,18.667L14.000,18.667L14.000,15.333L10.667,15.333L10.667,14.000L14.000,14.000L14.000,10.667L15.333,10.667L15.333,14.000L18.667,14.000Z",
    className: "clr-i-solid clr-i-solid-path-2",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-50002c00-9627-80a8-8005-e4f18e0249ee"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-50002c00-9627-80a8-8005-e4f18e0249ee"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "none"
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForwardClone);
export default __webpack_public_path__ + "static/media/icon-forward-clone.1d215a47a5e0d590426865131b06ad24.svg";
export { ForwardRef as ReactComponent };